export default function copyObject(fromObject, toObject) {
    for (const key in fromObject) {
        if (fromObject.hasOwnProperty(key)) {
            toObject[key] = fromObject[key];
        }
    }
}